import { Component } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";

import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";

export default class UsersContactDataComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Country: "SE",
      BankId: "",
      BankNumber: "",
      HolderName: "",
      Kind: "",
      Currency: "",
      SEIdentifier: "",
      IBANIdentifier: "",
    };
  }

  componentDidMount() {
    this.props.getBanks();
  }

  addBankAccount = () => {
    let data = Object.assign({}, this.state, {
      Identity: this.props.currentUser.Identity,
    });
    this.props.addBankAccount(data, this.props.currentUser.Id);
  };

  handleFormInput = (kay, event) => {
    this.setState({
      [kay]: event.target.value,
    });
  };

  render() {
    let addBankAccountForLegalEntityTemplate;
    let currentUser = this.props.currentUser;

    if (!currentUser) {
      return <div>loading</div>;
    }

    if (currentUser.Domain === "Savelend") {
      let inputStyle = {
        float: "left",
        maxWidth: "300px",
        paddingRight: "30px",
      };
      addBankAccountForLegalEntityTemplate = (
        <div>
          <Divider />
          <CardHeader title="Add Bank account" />
          <CardContent>
            <TextField
              size="small"
              variant="outlined"
              label="Country"
              value={this.state.Country}
              onChange={this.handleFormInput.bind(this, "Country")}
              select
            >
              <MenuItem key="FI" value="FI">
                Finland
              </MenuItem>
              <MenuItem key="SE" value="SE">
                Sweden
              </MenuItem>
              <MenuItem key="DK" value="DK">
                Denmark
              </MenuItem>
              <MenuItem key="LT" value="LT">
                Lithuania
              </MenuItem>
              <MenuItem key="DE" value="DE">
                Germany
              </MenuItem>
              <MenuItem key="AT" value="AT">
                Austria
              </MenuItem>
              <MenuItem key="BE" value="BE">
                Belgium
              </MenuItem>
              <MenuItem key="CH" value="CH">
                Switzerland
              </MenuItem>
            </TextField>
            <div style={{ clear: "both" }} />
            <div style={inputStyle}>
              <TextField
                id="outlined-select-currency"
                size={"small"}
                select
                label="Bank Name"
                value={this.state.BankId}
                onChange={this.handleFormInput.bind(this, "BankId")}
                variant="outlined"
              >
                {this.props.availableBankAccounts.data !== undefined &&
                  this.props.availableBankAccounts.data
                    .filter((opt) => opt.Country === this.state.Country)
                    .sort((a, b) => a.Name > b.Name)
                    .map((option) => {
                      return (
                        <MenuItem key={option.BankId} value={option.BankId}>
                          {option.Name + " (" + option.Bic + ")"}
                        </MenuItem>
                      );
                    })}
              </TextField>
            </div>
            <div style={inputStyle}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth={true}
                label="Bank Number (display name) *"
                value={this.state.BankNumber}
                onChange={this.handleFormInput.bind(this, "BankNumber")}
              />
            </div>
            <div style={inputStyle}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth={true}
                label="Holder Name *"
                value={this.state.HolderName}
                onChange={this.handleFormInput.bind(this, "HolderName")}
              />
            </div>
            <div style={{ clear: "both" }} />
            <div style={inputStyle}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth={true}
                label="Kind"
                value={this.state.Kind}
                onChange={this.handleFormInput.bind(this, "Kind")}
              />
            </div>
            <div style={inputStyle}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth={true}
                label="Currency"
                value={this.state.Currency}
                onChange={this.handleFormInput.bind(this, "Currency")}
                select
              >
                <MenuItem key="SEK" value="SEK">
                  SEK
                </MenuItem>
                <MenuItem key="EUR" value="EUR">
                  EUR
                </MenuItem>
              </TextField>
            </div>
            <div style={inputStyle}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth={true}
                label="SE identifier"
                value={this.state.SEIdentifier}
                onChange={this.handleFormInput.bind(this, "SEIdentifier")}
              />
            </div>
            <div style={inputStyle}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth={true}
                label="IBAN identifier"
                value={this.state.IBANIdentifier}
                onChange={this.handleFormInput.bind(this, "IBANIdentifier")}
              />
            </div>

            <div>
              <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.addBankAccount}
                >
                  Add Account
                </Button>
              </ClaimsWrapper>
            </div>
          </CardContent>
        </div>
      );
    }

    return (
      <div className="user-panel-box">
        <CardHeader
          title="Emails"
          subheader={
            <div>
              {currentUser.EmailData.Emails.map((email, index) => {
                return (
                  <div className="row" key={"email_" + index}>
                    <div className="col-md-12">{email.EmailAddress}</div>
                  </div>
                );
              })}
              {currentUser.EmailData.RawEmails.map((email, index) => {
                return (
                  <div className="row" key={"raw_" + index}>
                    <div className="col-md-12">{email.EmailAddress}</div>
                  </div>
                );
              })}
            </div>
          }
        />
        <Divider />
        <CardHeader
          title="Phones"
          subheader={
            <div>
              {currentUser.PhoneNumbers.MobilePhones.map((phone, index) => {
                return (
                  <div className="row" key={"phone_" + index}>
                    <div className="col-md-12">{phone.Number}</div>
                  </div>
                );
              })}
            </div>
          }
        />
        <Divider />
        <CardHeader
          title="Bank accounts"
          subheader={currentUser.BankAccounts.map((bank, index) => {
            return (
              <div className="row" key={"bank_" + index}>
                <div className="col-md-12">
                  Number (display number): {bank.Number}
                  <strong>
                    {this.props.bankAccountId &&
                    bank.Id === this.props.bankAccountId
                      ? " - CHOSEN DIRECT DEBIT ACCOUNT"
                      : ""}
                  </strong>
                  <br />
                  Iban: {bank.IbanIdentifier} <br />
                  Bban: {bank.SeIdentifier} <br />
                  Holder name: {bank.HolderName} <br />
                  Bank name: {bank.BankName} ({bank.Bic}) <br />
                  Kind: {bank.Kind} <br />
                  Id: {bank.Id} (currency: {bank.Currency}) <br />
                  <br />
                </div>
              </div>
            );
          })}
        />
        {addBankAccountForLegalEntityTemplate}
      </div>
    );
  }
}
